<app-loading *ngIf="isLoading$ | async" [options]="loadingOpts$ | async"> </app-loading>

<div class="app-body mt-0 mb-0">
  <!-- Nav Bar -->
  <app-sidebar-navigation
    *rxLet="sidebarVisible$ as visible"
    [hidden]="!visible"
    [class.sidebar-show]="visible"
    [class.sidebar-hide]="!visible"
    class="sidebar">
  </app-sidebar-navigation>
  <!-- Main content -->
  <main class="main">
    <main class="main-content" [class.bud-bot]="viewModel.isBudBot$ | async">
      <router-outlet></router-outlet>
      <app-toast-events></app-toast-events>
    </main>
  </main>
</div>
